import { render, staticRenderFns } from "./EpicList.vue?vue&type=template&id=6a37eaea&scoped=true&"
import script from "./EpicList.vue?vue&type=script&lang=js&"
export * from "./EpicList.vue?vue&type=script&lang=js&"
import style0 from "./EpicList.vue?vue&type=style&index=0&id=6a37eaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37eaea",
  null
  
)

export default component.exports